module.exports = __webpack_public_path__ + "img/bg-waiting.80234400.svg";